import React, { useCallback, useContext, useEffect, useState } from 'react'

import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { Box, Button, Grid } from '@mui/material';
import { ContextUserInfo } from '../MainPanel';
import { ContextNotification, severitys } from '../../../App';
import enumMapper from '../../../enumMapper';
import reservationApi from '../../../api/reservationApi';
import ConfirmationDialog from '../../../Components/ConfirmationDialog';



const ActiveCurrentReservationForm = ({ row, refreshGrid }) => {
  const { userInfo, userPermissions, userRoles } = useContext(ContextUserInfo);
  const { open, setOpen } = useContext(ContextNotification);

  const [activeCurrentReservation, setActiveCurrentReservation] = useState(null)
  const [openDeActiveReserve, setOpenDeActiveReserve] = useState(false);
  const schema = yup.object().shape({

  });
  const { register, setValue, handleSubmit, formState: { errors }, control, resetField, reset, getValues, watch } = useForm({
    defaultValues: {

    },
    resolver: yupResolver(schema),
  });


  const onSubmit = (data) => {

  };

  useEffect(() => {
    const parsedRow = JSON.parse(row.message)
    const newData = {
      "fromDate": parsedRow.FromDate,
      "toDate": parsedRow.ToDate,
      "dispatchOfTheDay": parsedRow.DispatchOfTheDay,
      "planCode": parsedRow.PlanCode,
      "hotelId": parsedRow.HotelId
    }
    reservationApi.ActiveCurrentReservation(newData)
      .then(res => {
        setActiveCurrentReservation(res.data)
      })
      .catch(err => console.log(err))
  }, []);
  const handleOpenDeActiveReserve = () => {
    setOpenDeActiveReserve(true);
  };
  const handleDeActiveReserve = (id) => {
    reservationApi.DeActiveReserve(id).then((res) => {
      if (res.data.success) {
        setOpen({ IsEnable: true, Message: res.data.message, severity: severitys.success });
        refreshGrid(true)
      }
      else {
        setOpen({ IsEnable: true, Message: res.data.message, severity: severitys.error });
      }
    }).catch(err => {
      if (err.response && err.response.data && err.response.data.errors) {
        setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
      }
      else if (err.response && err.response.data) {
        setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data), severity: severitys.error });
      }
      else if (err.message) {
        setOpen({ IsEnable: true, Message: JSON.stringify(err.message), severity: severitys.error });
      }
      else {
        setOpen({ IsEnable: true, Message: JSON.stringify(err), severity: severitys.error });
      }
    }
    ).finally(() => setOpenDeActiveReserve(false));
  };
  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Box
          sx={{


          }}
        >
          {
            activeCurrentReservation?.data ? <Box>
              <p>نام کاروان: {activeCurrentReservation.data.brokerName}</p>
              <p>شماره کاروان: {activeCurrentReservation.data.brokerCode}</p>
              <p>شرکت مجری: {activeCurrentReservation.data.companyName}</p>
              <p>شماره گروه: {activeCurrentReservation.data.groupNumber}</p>
              <Button variant="contained" color="primary" onClick={() => {
                handleOpenDeActiveReserve()
              }}>DeActiveReserve</Button>
              <ConfirmationDialog
                open={openDeActiveReserve}
                handleClose={() => setOpenDeActiveReserve(false)}
                func={() => handleDeActiveReserve(activeCurrentReservation?.data.reserveId)}
                title={"آیا از غیرفعال کردن این رزرو اطمینان دارید؟"}
              />
            </Box> : <Box>{activeCurrentReservation?.message}</Box>
          }
        </Box>


      </form>
    </div>
  )
}

export default ActiveCurrentReservationForm